import { MANUAL_INPUT_CONSTRUCTION_ID } from "~/constants/DealConstructionConst";
import type { DealConstructionEdit } from "~/models/DealConstruction";

type DealConstructionPayload = Omit<
	DealConstructionEdit,
	"dealConstructionItem"
> & {
	dealConstructionItem: { id: number } | null;
};

/**
 * DealConstructionEditをAPI送信用のペイロードに変換する
 * dealConstructionItem.id === MANUAL_INPUT_CONSTRUCTION_ID の場合は直接入力なので、otherNameに変換する
 */
export const convertDealConstructionToPayload = (
	dealConstruction: DealConstructionEdit
): DealConstructionPayload => {
	const { dealConstructionItem, ...rest } = dealConstruction;

	// 直接入力の場合
	if (dealConstructionItem?.id === MANUAL_INPUT_CONSTRUCTION_ID) {
		return {
			...rest,
			dealConstructionItem: null,
			otherName: dealConstructionItem.name
		};
	}

	// 通常の施工項目の場合
	return {
		...rest,
		dealConstructionItem: dealConstructionItem
			? { id: dealConstructionItem.id }
			: null,
		otherName: "" // 通常の施工項目選択時はotherNameを使用しないため空にする
	};
};
